import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=5ca8380a&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"
import style0 from "./Blog.vue?vue&type=style&index=0&id=5ca8380a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8380a",
  null
  
)

export default component.exports